export const HOME_PATH = '/customer';
